import styled from 'styled-components';

export default function InformationSection() {
  return (
    <Wrapper>
      <h3>Contato</h3>
      <p>
        <span>Email:</span> contato@nossavaquinha.com.br
      </p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex: 1;
  margin-right: 3rem;
  margin-bottom: 3rem;
  background: #FBF9ED;
 
  h3 {
    font-family: 'P22 Mackinac Pro';
    font-style: normal;
    font-weight: 500;
    font-size: 4rem;
    line-height: 120%;

    color: #174F68;
    margin-bottom: 2rem;
  }

  p {
    font-weight: normal;
    font-size: 1.6rem;
    color: #222222, 0.7;
  }

  span {
    opacity: 1;
    color: rgba(var(--text), 1);
  }
`;
